import { useUserContext } from "@/components/user-context";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { LoggedOutDevAIFree } from "./free";
import { LoggedOutRovoDevStandard } from "./standard";

export const LoggedOutDevAI = () => {
    const { edition } = useUserContext();

    if (
        edition === "free" &&
        checkFeatureFlagGate(featureFlags.enableRovoDevBetaSignup)
    ) {
        return <LoggedOutDevAIFree />;
    }

    return <LoggedOutRovoDevStandard />;
};
